import { InteractiveComponentProps } from "./interactive-component-plugin";

export const InteractiveComponentFactorySymbol = Symbol.for("InteractiveComponentFactorySymbol");
export type InteractiveComponentFactory<TState, TContent> =
      (componentType: string,
       propsData: InteractiveComponentProps<TState, TContent>) => InteractiveVueComponent<TState, TContent>

export interface InteractiveVueComponent<TState, TProps> extends Vue {
  propsData: () => InteractiveComponentProps<TState, TProps>;
}
